import { isBefore, parseISO } from 'date-fns';

export const weekDaysShort = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

export const getInitialState = (defaults) => {
  return { start: null, end: null, hoveredEnd: null, ...defaults };
};

export const determineNextRange = (day, range) => {
  if (!range.start) {
    return { start: day, end: null, hoveredEnd: null };
  }

  if (range.start === day) {
    return getInitialState();
  }

  if (range.end === day) {
    return { start: day, end: null, hoveredEnd: null };
  }

  if (isBefore(parseISO(day), parseISO(range.start))) {
    return { start: day, end: range.end, hoveredEnd: null };
  } else {
    return { start: range.start, end: day, hoveredEnd: null };
  }
};
